import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import { ConfigProvider, Pagination } from "antd";
import dayjs from 'dayjs';
import Select from 'react-select';
function StudentReference({ serverURL, user, setUser, setShowSideOverlay, socket, onlineUsers }) {

    const [allReferrals, setAllReferrals] = useState([])
    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)
    const [currentPageNumber, setCurrentPageNumber] = useState(1)

    const getAllRecords = async () => {
        const query = {
            "skip": skipEntries,
            "limit": entriesLimit
        }
        const getNow = await axios.post(serverURL + "/referal/getAll", query)
        if (getNow.status === 200) {
            console.log(getNow.data)
            setAllReferrals(getNow.data.records)
            setTotalEntriesCount(getNow.data.total)
        } else {
            console.log(getNow.data)
        }
    }


    const updateReferal = async (id, type, values) => {
        const query = {
            "id": id,
            "type": type,
            "values": values,
            "editedBy": {
                "name": user.name,
                "email": user.email,
                "id": user._id,
            }
        }
        const updateNow = await axios.post(serverURL + "/referal/update", query)
        if (updateNow.status === 200) {
            console.log(updateNow.data)
            getAllRecords()
        } else {
            console.log(updateNow.data)
        }
    }



    useEffect(() => {
        getAllRecords()
    }, [entriesLimit, skipEntries])


    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Student Reference</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='my-3'>

                </div>
                <div className='w-100 h-100 overflow-auto'>

                    <table className='table table-bordered table-striped table-yesgermany m-0'>
                        <thead>
                            <tr align="middle">
                                <th className='text-nowrap' width="1%">#{totalEntriesCount}</th>
                                <th className='text-nowrap' width="1%">Referral Date</th>
                                <th className='text-nowrap' width="1%">Name</th>
                                <th className='text-nowrap' width="1%">Email</th>
                                <th className='text-nowrap' width="1%">Mobile</th>
                                <th className='text-nowrap' width="1%">Course</th>
                                <th className='text-nowrap' width="1%">Eligibility</th>
                                <th className='text-nowrap' width="1%">Registration/Process</th>
                                <th className='text-nowrap' width="1%">Reward</th>
                                <th className='text-nowrap' width="1%">Updated On</th>
                                <th className='text-nowrap' width="1%">Updated By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allReferrals ?
                                    allReferrals.length > 0 ?
                                        allReferrals.map((ref, key) => {
                                            return (
                                                <tr align="middle" valign="middle" key={key}>
                                                    <td className='text-nowrap'>{key + 1}</td>
                                                    <td className='text-nowrap'>{dayjs(ref.Date).format("D MMM YYYY")}</td>
                                                    <td className='text-nowrap'>{ref.Name}</td>
                                                    <td className='text-nowrap'>{ref.Email}</td>
                                                    <td className='text-nowrap'>{ref.Mobile}</td>
                                                    <td className='text-nowrap'>{ref.Course}</td>
                                                    <td className='text-nowrap'>
                                                        <Select
                                                            className='w-100 text-nowrap'
                                                            placeholder="Chose Eligibility"
                                                            onChange={(e) => { updateReferal(ref._id, "eligibility", e) }}
                                                            autoFocus={false}
                                                            isMulti={false}
                                                            isSearchable={false}
                                                            required={false}
                                                            isDisabled={!user.permissions.some(
                                                                (data) => data.value === "Student-Reference-Update"
                                                            )}
                                                            options={[{ "label": "Eligible", "value": "Eligible" }, { "label": "Non-Eligible", "value": "Non-Eligible" }]}
                                                        />
                                                    </td>
                                                    <td className='text-nowrap'>
                                                        <Select
                                                            className='w-100 text-nowrap'
                                                            placeholder="Chose Process"
                                                            onChange={(e) => { updateReferal(ref._id, "process", e) }}
                                                            autoFocus={false}
                                                            isMulti={false}
                                                            isSearchable={false}
                                                            required={false}
                                                            isDisabled={!user.permissions.some(
                                                                (data) => data.value === "Student-Reference-Update"
                                                            )}
                                                            options={[
                                                                { "label": "Not Started", "value": "Not Started" },
                                                                { "label": "In Process", "value": "In Process" },
                                                                { "label": "Completed", "value": "Completed" },
                                                                { "label": "Drop Out", "value": "Drop Out" },
                                                            ]}
                                                        />
                                                    </td>
                                                    <td className='text-nowrap' valign='middle'>
                                                        <Select
                                                            className='w-100 text-nowrap'
                                                            placeholder="Chose Status"
                                                            onChange={(e) => { updateReferal(ref._id, "status", e) }}
                                                            autoFocus={false}
                                                            isMulti={false}
                                                            isSearchable={false}
                                                            required={false}
                                                            isDisabled={!user.permissions.some(
                                                                (data) => data.value === "Student-Reference-Update"
                                                            )}
                                                            options={[
                                                                { "label": "Not Paid", "value": "Not Paid" },
                                                                { "label": "In Process", "value": "In Process" },
                                                                { "label": "Paid", "value": "Paid" },
                                                            ]}
                                                        />
                                                    </td>
                                                    <td className='text-nowrap'>{dayjs(ref.updatedAt).format("D MMM YYYY, h:mma")}</td>
                                                    <td className='text-nowrap'>{ref.editedBy?.email}</td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr><td colSpan={"100%"}></td></tr>
                                    :
                                    <tr><td colSpan={"100%"}></td></tr>
                            }
                        </tbody>
                    </table>

                    <div className='w-100 mt-2 customBackgroundFilter rounded'>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Pagination: {
                                        itemActiveBg: "#faf089",
                                        itemActiveBgDisabled: "yellow",
                                        // itemActiveColorDisabled: "",
                                        // itemBg: "",
                                        // itemInputBg: "",
                                        // itemLinkBg: "",
                                    },
                                },
                                token: {
                                    // colorBgContainer: "",
                                    // colorBgContainerDisabled: "",
                                    // colorBgTextActive: "",
                                    colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                    // colorBorder: "red",
                                    // colorPrimary: "",
                                    // colorPrimaryBorder: "#faf089",
                                    // colorPrimaryHover: "",
                                    // colorText: "",
                                    // colorTextDisabled: "",
                                    // colorTextPlaceholder: "",
                                    // borderRadius: "",
                                    // borderRadiusLG: "",
                                    // borderRadiusSM: "",
                                    // controlHeight: "",
                                    // controlOutline: "",
                                    // controlOutlineWidth: "",
                                    // fontFamily: "",
                                    // fontSize: "",
                                    // lineHeight: "",
                                    margin: 0,
                                    // motionDurationMid: "",
                                    // paddingXXS: ""
                                }
                            }}
                        >
                            <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                        </ConfigProvider>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StudentReference